/**
 * PingPongLand release version.
 *
 * Current release line starts at 1.0.1.0 and increments the final component:
 * 1.0.1.0 → 1.0.1.1 → 1.0.1.2 → 1.0.1.3 → 1.0.1.4 → 1.0.1.5 → 1.0.1.6 → 1.0.1.7 → 1.0.1.8 → 1.0.1.9 → 1.0.1.10 → 1.0.1.11 → 1.0.1.12 → 1.0.1.13 → 1.0.1.14 → 1.0.1.15 → 1.0.1.16 → 1.0.1.17 → 1.0.1.18 → 1.0.1.19 → 1.0.1.20 → 1.0.1.21 → 1.0.1.22 → 1.0.1.23 → 1.0.1.24 → 1.0.1.25 → 1.0.1.26 → 1.0.1.27 → 1.0.1.28
 *
 * Commit subjects must include the same version as `[vX.X.X.X]`.
 */
export const APP_VERSION = '1.0.1.28'
